import { render, staticRenderFns } from "./GroupDashboard.vue?vue&type=template&id=b8034494&"
import script from "./GroupDashboard.vue?vue&type=script&lang=js&"
export * from "./GroupDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports